// extracted by mini-css-extract-plugin
export default {"root":"SrvTableActions_root__CEA-t","action":"SrvTableActions_action__wf88F","linkAction":"SrvTableActions_linkAction__llCOQ"};